import React from 'react'
import { useDispatch } from 'react-redux'
import loadable from '@loadable/component'
import { rootActions } from '@store/slices'
import { getSubDomain } from '@features/Auth'
import { loadableOptions } from '@components/App'
import usePath from '@hooks/processor/usePath'
import styles from './index.scss'

const MeetingCalendar = loadable(
    () => import('@pages/Settings/Communications/Campaign/MeetingRequest/Calendar'),
    loadableOptions
)
const Error = () => {
    const dispatch = useDispatch()
    const subdomain = getSubDomain()
    const { pathSections: path } = usePath()
    const [loading, setLoading] = React.useState<boolean>(true)
    const [originalUrl, setOriginalUrl] = React.useState<string>('')
    const [error, setError] = React.useState('')

    React.useEffect(() => {
        //subdomain meeting is for requesting direct meeting by link wihtout login
        if (!['localhost', 'meeting', 'dev'].includes(subdomain)) {
            if (path.length && path[0] && path[0] !== 'organizer') {
                dispatch(
                    rootActions.properties.oneUrl.onRequest({
                        urlId: path[0],
                        sagaCB: {
                            onSuccess: res => {
                                if (res.originalUrl) {
                                    // const path = res.originalUrl.substr(res.originalUrl.indexOf('.com') + 4, 1000)
                                    setOriginalUrl(
                                        res.originalUrl.includes('http://') || res.originalUrl.includes('https://')
                                            ? res.originalUrl
                                            : `https://${res.originalUrl}`
                                    )
                                } else {
                                    setOriginalUrl('')
                                    setLoading(false)
                                }
                            },
                            onError: error => {
                                setOriginalUrl('')
                                setLoading(false)
                                setError(error)
                            }
                        }
                    })
                )
            }
        }
    }, [])

    if (originalUrl) {
        window.location.href = originalUrl
    }
    return (
        <>
            {['localhost', 'meeting', 'dev'].includes(subdomain) && <MeetingCalendar />}
            {!loading && (
                <div className={styles.centered}>
                    <div className={styles.title}>Ooooops!</div>
                    <div>{error || 'This page does not exist anymore.'}</div>
                </div>
            )}
        </>
    )
}

export default Error
